import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'sb-dialog-block-row',
  standalone: true,
  templateUrl: './dialog-block-row.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  // eslint-disable-next-line @angular-eslint/no-host-metadata-property
  host: {
    class: 'grid grid-cols-2 gap-x-2',
    '[class.text-red-600]': 'hasError',
  },
})
export class SbDialogBlockRowComponent {
  @Input({ required: true })
  public label!: string | SafeHtml;

  @Input()
  hasError = false;
}
